/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    FIX_BROADCASTS_IMPORT
 * Date:         2026-01-01
 * Modified By:  Cursor
 *
 * Description:
 * Fixed import error - changed BroadcastsTabs from named import to default import
 * to match the export statement in BroadcastsTabs.tsx.
 *
 * Related Screens / Modules:
 * - client/src/features/broadcast/pages/broadcasts-list/BroadcastsListPage.tsx
 * - client/src/features/broadcast/pages/broadcasts-list/components/BroadcastsTabs.tsx
 */
/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    ALLBROADCASTS_SIDEBAR_FILTER
 * Date:         2026-01-01
 * Modified By:  Cursor
 *
 * Description:
 * Updated for /allbroadcasts route change and sidebar layout integration.
 *
 * File Size Check:
 * - Current: 37 lines
 * - Adding: ~15 lines
 * - Projected: 52 lines
 * - Decision: Proceed (within limit)
 *
 * Related Screens / Modules:
 * - client/src/features/broadcast/pages/broadcasts-list/BroadcastsListPage.tsx
 */
/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    DASHBOARD_BROADCAST_REDESIGN_PHASE3
 * Date:         2025-12-31
 * Modified By:  Cursor
 *
 * Description:
 * Main page component for broadcasts list at /allbroadcasts route.
 * Renders header and tabs component (Phase 3).
 *
 * File Size Check:
 * - Estimated: ~70 lines (Phase 3 simplified)
 * - Decision: Proceed (within 200-line component limit)
 *
 * Related Screens / Modules:
 * - client/src/features/broadcast/pages/broadcasts-list/BroadcastsListPage.tsx
 * - client/src/features/broadcast/pages/broadcasts-list/components/BroadcastsTabs.tsx
 */

import React from "react";
import BroadcastsHeader from "./components/BroadcastsHeader";
// [2026-01-01] Fix: Changed from named to default import
import BroadcastsTabs from "./components/BroadcastsTabs"; // [2025-12-31] Phase 3
import styles from "./BroadcastsListPage.module.scss";

const BroadcastsListPage: React.FC = () => {
  return (
    <div className={styles.pageContainer}>
      <BroadcastsHeader />
      {/* [2025-12-31] Phase 3: BroadcastsTabs component with data fetching */}
      <BroadcastsTabs />
    </div>
  );
};

export default BroadcastsListPage;
